/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {formatDate} from "@angular/common";
import {Component} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {FabMessageService} from "@fabric/components/message";
import {ColDef} from 'ag-grid-community';
import {DISMISS_MSG} from "../../../common/constants";
import {StateService} from "../../../core/state/state.service";
import {ExcelExportService} from "../../../services/excel-export.service";
import {GlobalScenarioService} from "../../../services/global-scenario-service";

@Component({
    selector: 'app-global-propulsion-forecast-template',
    templateUrl: './global-propulsion-forecast-template.html',
    styleUrl: './global-propulsion-forecast-template.scss',
    standalone: false
})
export class GlobalPropulsionForecastTemplateComponent {
  showSpinner: boolean;

  selectedGlobalScenario: any = undefined;

  displayedMemberHeaders: ColDef[] = [
    {field: 'vehScenId', headerName: 'Vehicle Scenario ID', lockPosition: true},
    {field: 'vehScenName', headerName: 'Vehicle Scenario Name', lockPosition: true},
    {field: 'fcorg', headerName: 'FCORG', lockPosition: true},
    {field: 'propulsionScenario.id', headerName: 'Propulsion Scenario ID', lockPosition: true},
    {field: 'propulsionScenario.propulsionScenarioName', headerName: 'Propulsion Scenario Name', lockPosition: true},
  ];

  constructor(readonly stateService: StateService,
              readonly globalScenarioService: GlobalScenarioService,
              readonly excelExportService: ExcelExportService,
              public dialog: MatDialog,
              public snackBar: FabMessageService) {

  }

  /**
   * Export the report containing propulsion records for a Global Scenario
   */
  exportReport(): void {
    this.showSpinner = true;
    const currDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    const fileName = 'GlblPropFT_' + this.selectedGlobalScenario.globalScenarioName + '_' + currDate;
    this.globalScenarioService.globalPropulsionRecordReport(this.stateService.getUserGmid(),
      this.selectedGlobalScenario.id).subscribe(
      (file: any) => {
        this.excelExportService.exportToExcelFromServer(file, fileName);
      },
      () => {
        this.snackBar.displayError('Error with exporting data.', DISMISS_MSG);
        this.showSpinner = false;
      }, () => {
        this.showSpinner = false;
        this.snackBar.displaySuccess('Successfully retrieved propulsion records. Exporting...', DISMISS_MSG);
      });
  }

  /**
   * Event handler for when a selected Global Scenario is confirmed
   * @param data the data from the event
   */
  onScenarioSelection(data: any) {
    this.selectedGlobalScenario = data.globalScenario;
  }
}
